module.exports = __webpack_public_path__ + "static/torch-mtg_afr-cf90875f6dd8ed1662a010308a47f747.jpg";